import { render, staticRenderFns } from "./AddCellar2Registration.vue?vue&type=template&id=b556d766&scoped=true&"
import script from "./AddCellar2Registration.vue?vue&type=script&lang=js&"
export * from "./AddCellar2Registration.vue?vue&type=script&lang=js&"
import style0 from "./AddCellar2Registration.vue?vue&type=style&index=0&id=b556d766&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b556d766",
  null
  
)

export default component.exports